import { ChangeDetectorRef, Component, ElementRef, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import { CloudData, CloudOptions } from 'angular-tag-cloud-module';
import { ToasterService } from 'angular5-toaster/dist';

import * as htmlToImage from 'html-to-image';
import { SummaryFilterModel } from '../../models/summary/summary.model';
import { WordCloudResponseModel } from '../../models/survey/survey.model';
import { SurveyService } from '../../routes/surveys/surveys.service';
@Component({
  selector: 'app-word-cloud',
  templateUrl: './word-cloud.component.html',
  styleUrls: ['./word-cloud.component.less']
})
export class WordCloudComponent implements OnInit  {

  @Input() summaryFilterModel: SummaryFilterModel;
  @Input() surveyId: number;
  @Input() questionId: number;
  @Input() isSubgroup = false;
  @Input() dataSource: WordCloudResponseModel[];

  @Input() fontInp: string;
  @Input() limit: number;
  @Input() versionName: string;
  @ViewChild('screen') screen: ElementRef;
  @ViewChild('canvas') canvas: ElementRef;
  @ViewChild('downloadLink') downloadLink: ElementRef;
  notFoundData = false;
  isScale = false;
  options: CloudOptions = {
    // if width is between 0 and 1 it will be set to the width of the upper element multiplied by the value
    width: 2000,
    // if height is between 0 and 1 it will be set to the height of the upper element multiplied by the value
    height: 870,
    overflow: true,
  };
  dataCloudWord: CloudData[] = [
  ];
  dataCloudWordString = '';
  isDivVisible = true;
  showLoader = false;
  imageURL = '';
  showClipboard = false;
  showWordCloudModal = false;
  screenWith = 500;
  screenHeight = 300;
  enableCopyBtn = false;

  constructor(private cdRef: ChangeDetectorRef, private toasterService: ToasterService,
    private surveyService: SurveyService, private zone: NgZone) {
  }

  ngOnInit() {
    this.screenWith = window.innerWidth;
    this.screenHeight = window.innerHeight - 200;
    let limitCount = 0;
    const maxWidth = 45;
    const widthIncreasePerHeight = 2;
    if (this.isSubgroup) {
      if (this.dataSource && this.dataSource.length > 0) {
        this.showLoader = true;
        this.dataSource.forEach(wordCloudResponseModel => {
          if (limitCount < this.limit) {
            const limitWidth = maxWidth - (wordCloudResponseModel.answerWeight * widthIncreasePerHeight);
            this.dataCloudWord = [...this.dataCloudWord, {text: this.truncateText(wordCloudResponseModel.answerName, limitWidth),
              weight: wordCloudResponseModel.answerWeight, color: wordCloudResponseModel.colorHex}];
            limitCount++;
          }
        });
      }
      this.renderImageCanvas();
    } else {
      this.showLoader = true;
      let versionHash;
      let cutId = null;
      const version = this.summaryFilterModel.includeSurvey.listSurveyVersion.find( item => item.surveyName === this.versionName);
      const includesrvy = this.summaryFilterModel.includeSurvey;
      const listQstnFilter = this.summaryFilterModel.listQuestionFilter;
      const summaryFilter = JSON.parse(JSON.stringify(this.summaryFilterModel));
      summaryFilter.includeSurvey.listSurveyVersion = includesrvy && includesrvy.listSurveyVersion ? includesrvy.listSurveyVersion : [];
      summaryFilter.includeSurvey.listSurveyCut = includesrvy && includesrvy.listSurveyCut ? includesrvy.listSurveyCut : [];
      summaryFilter.listQuestionFilter = listQstnFilter;
      if (version) {
        versionHash = version.hash;
        summaryFilter.includeSurvey.listSurveyVersion = summaryFilter.includeSurvey.listSurveyVersion
          .filter(survey => survey.hash === version.hash);
        summaryFilter.includeSurvey.listSurveyCut = [];
      } else if (includesrvy.listSurveyCut && includesrvy.listSurveyCut.find(cut => cut.title === this.versionName)) {
        cutId = includesrvy.listSurveyCut.find(cut => cut.title === this.versionName).id;
        summaryFilter.includeSurvey.listSurveyVersion = [];
      }
      versionHash = versionHash ? versionHash : '';
      cutId = cutId ? cutId : '';
      this.surveyService.getResponseTextByQuestion(this.surveyId, this.questionId, summaryFilter, versionHash, cutId).subscribe(res => {
        this.dataSource = res;
        if (this.dataSource && this.dataSource.length > 0) {
          this.limit = this.dataSource[0].limit;
          this.dataSource.forEach(wordCloudResponseModel => {
            if (limitCount < this.limit) {
              const limitWidth = maxWidth - (wordCloudResponseModel.answerWeight * widthIncreasePerHeight);
              this.dataCloudWord = [...this.dataCloudWord, {text: this.truncateText(wordCloudResponseModel.answerName, limitWidth),
                weight: wordCloudResponseModel.answerWeight, color: wordCloudResponseModel.colorHex}];
              limitCount++;
            }
          });
        }
        this.renderImageCanvas();
      }, _ => {
        this.showLoader = false;
      });
    }

  }

  scaleImage() {
    this.showWordCloudModal = true;
    // this.isScale = !this.isScale;
  }

  downloadImage() {
    this.downloadLink.nativeElement.href = this.imageURL;
    this.downloadLink.nativeElement.download = 'word-cloud.jpeg';
  }
  truncateText(text: string, limit: number) {
    if (text.length > limit) {
      return text.substring(0, limit - 2) + '...';
    }
    return text;
  }

  renderImageCanvas() {
    const self = this;
    self.showLoader = true;
    self.cdRef.detectChanges();
    if (this.screen) {
      const node = this.screen.nativeElement;
      const option = {
        height: 870,
        width: 2150,
        quality: 1,
      };
      htmlToImage.toCanvas(node, option )
        .then(function (canvas) {
          self.imageURL = self.trimCanvas(canvas);
          self.screen.nativeElement.remove();
          self.showLoader = false;
          self.cdRef.detectChanges();
        })
        .catch(function (error) {
          console.error('oops, something went wrong!', error);
          self.showLoader = false;
        });
    } else {
      self.showLoader = false;
    }
  }
  trimCanvas(c) {
    let ctx = c.getContext('2d'),
        copy = document.createElement('canvas').getContext('2d'),
        pixels = ctx.getImageData(0, 0, c.width, c.height),
        l = pixels.data.length,
        i,
        bound = {
            top: null,
            left: null,
            right: null,
            bottom: null
        },
        x, y;

    // Iterate over every pixel to find the highest
    // and where it ends on every axis ()
    for (i = 0; i < l; i += 4) {
        if (pixels.data[i + 3] !== 0) {
            x = (i / 4) % c.width;
            y = ~~((i / 4) / c.width);

            if (bound.top === null) {
                bound.top = y;
            }

            if (bound.left === null) {
                bound.left = x;
            } else if (x < bound.left) {
                bound.left = x;
            }

            if (bound.right === null) {
                bound.right = x;
            } else if (bound.right < x) {
                bound.right = x;
            }

            if (bound.bottom === null) {
                bound.bottom = y;
            } else if (bound.bottom < y) {
                bound.bottom = y;
            }
        }
    }

    // Calculate the height and width of the content
    let trimHeight = bound.bottom - bound.top + 50,
        trimWidth = bound.right - bound.left + 50,
        trimmed = ctx.getImageData(bound.left - 20 , bound.top - 20 , trimWidth, trimHeight);

    copy.canvas.width = trimWidth + 10;
    copy.canvas.height = trimHeight + 10;
    copy.putImageData(trimmed, 0, 0);

    // Return trimmed canvas
    return copy.canvas.toDataURL('image/png', 1);
  }
  showRawText() {
    this.showClipboard = true;
    this.enableCopyBtn = false;
  }
  showChange(event) {
    this.showClipboard = event;
  }

}




// WEBPACK FOOTER //
// ./src/app/shared/word-cloud/word-cloud.component.ts